import axios, { AxiosResponse } from 'axios';
import type { LogReportData, LogReportResponse } from '@/types/log';

/**
 * 日志 API 基础 URL
 */
const LOG_API_BASE_URL = import.meta.env.VITE_LOG_API_URL || 'https://log-dev.felo.me';

/**
 * 创建日志 API axios 实例
 */
const logApiClient = axios.create({
  baseURL: LOG_API_BASE_URL,
  timeout: 5000, // 5秒超时
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * 上报日志数据到自定义日志系统
 *
 * @param data - 日志数据
 * @returns Promise<AxiosResponse<LogReportResponse>>
 */
export const reportLog = async (
  data: LogReportData,
): Promise<AxiosResponse<LogReportResponse>> => {
  try {
    const response = await logApiClient.post<LogReportResponse>('/api/data/report', data);
    return response;
  } catch (error) {
    // 日志上报失败不应该抛出异常，避免影响业务流程
    console.error('[Log API] Failed to report log:', error);
    throw error;
  }
};
